module.exports = __webpack_public_path__ + "static/media/LRM_EXPORT_20171119_213942-01.cac69915.jpg";